import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'gx-button',
  templateUrl: './gx-button.component.html',
  styleUrls: ['./gx-button.component.scss']
})
export class GxButtonComponent implements OnInit {
  @Input() enabled = true;

  constructor() { }

  ngOnInit(): void {
  }

  public onClick(): void {

  }

}
